export class Race {
  id: string;
  name: string;
}
